// Tier selection only ever happens on click — the tier rows' own
// selected/dimmed styling is handled entirely by CSS via :checked on
// the native radio inputs (see tayab-bioactivity-grading.css), no JS
// involved there. This custom element exists solely to sync the batch
// card (a separate column, so nothing native connects it to the
// radios) when the selection changes. Deliberately not wired to any
// scroll/intersection logic — the entrance animation reuses Dawn's
// existing scroll-trigger class instead of anything in this file.
class TayabBioactivityGrading extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => {
      const input = event.target;
      if (input.type !== 'radio') return;

      const badgeEl = this.querySelector('[data-bioactivity-badge]');
      const thumbEl = this.querySelector('[data-bioactivity-thumb]');
      const fillEl = this.querySelector('[data-bioactivity-fill]');

      if (badgeEl) badgeEl.textContent = input.dataset.badgeLabel;
      if (thumbEl) thumbEl.style.left = `${input.dataset.gaugePosition}%`;
      if (fillEl) fillEl.style.width = `${input.dataset.gaugePosition}%`;
    });
  }
}

if (!customElements.get('tayab-bioactivity-grading')) {
  customElements.define('tayab-bioactivity-grading', TayabBioactivityGrading);
}
